import { Card, CardContent, CardMedia, Typography, Box } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

interface BlogCardProps {
  title: string;
  excerpt: string;
  image?: string;
  date: string;
  readTime: string;
  slug: string;
  index: number;
}

export const BlogCard = ({
  title,
  excerpt,
  image,
  date,
  readTime,
  slug,
  index,
}: BlogCardProps) => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      style={{ height: "100%" }}
    >
      <Card
        onClick={() => navigate(`/blog/${slug}`)}
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            transform: "translateY(-8px)",
            boxShadow: (theme) => theme.shadows[4],
          },
        }}
      >
        <CardContent>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ mb: 1, display: "block" }}
          >
            {new Date(date + "T00:00:00Z").toLocaleDateString("en-US", {
              timeZone: "UTC",
            })}{" "}
            · {readTime} read
          </Typography>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "secondary.main" }}
          >
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {excerpt}
          </Typography>
        </CardContent>
      </Card>
    </motion.div>
  );
};
